const PlusBusRow = ({ stationName, quantity }) => (
  <div className="otrl-jp__favourite-ticket__plusbus__row">
    {`${quantity} x ${stationName} PlusBus`}
  </div>
);

export default PlusBusRow;